import { colors } from '@karnott/colors';
import { DANGER, INFO, SUCCESS, WARNING, getColorSeverity } from '@karnott/theme';

type ButtonColorMode = 'default' | 'outlined' | 'outlinedNeutral';
type ButtonState = 'default' | 'hovered' | 'disabled';
type ButtonColors = {
  bg: string;
  font: string;
  border: string;
};
type ButtonColorDefinition = Record<ButtonColorMode, Record<ButtonState, ButtonColors>>;

export const buttonColors = {
  default: {
    default: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(INFO)),
        border: colors(getColorSeverity(INFO)),
      },
      hovered: {
        bg: colors(getColorSeverity(INFO), 600),
        font: colors('white'),
        border: colors(getColorSeverity(INFO), 600),
      },
      disabled: {
        bg: colors('white', 400),
        font: colors(getColorSeverity(INFO)),
        border: colors('white', 400),
      },
    },
    outlined: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(INFO)),
        border: colors(getColorSeverity(INFO)),
      },
      hovered: {
        bg: colors(getColorSeverity(INFO)),
        font: colors('white'),
        border: colors(getColorSeverity(INFO)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(INFO), 400),
        border: colors(getColorSeverity(INFO), 400),
      },
    },
    outlinedNeutral: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(INFO)),
        border: colors('grey', 200),
      },
      hovered: {
        bg: colors(getColorSeverity(INFO)),
        font: colors('white'),
        border: colors(getColorSeverity(INFO)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(INFO), 400),
        border: colors('grey', 200),
      },
    },
  },
  primary: {
    default: {
      default: {
        bg: colors(getColorSeverity(WARNING)),
        font: colors('white'),
        border: colors(getColorSeverity(WARNING)),
      },
      hovered: {
        bg: colors(getColorSeverity(WARNING), 600),
        font: colors('white'),
        border: colors(getColorSeverity(WARNING), 600),
      },
      disabled: {
        bg: colors(getColorSeverity(WARNING), 400),
        font: colors('white'),
        border: colors(getColorSeverity(WARNING), 400),
      },
    },
    outlined: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(WARNING)),
        border: colors(getColorSeverity(WARNING)),
      },
      hovered: {
        bg: colors(getColorSeverity(WARNING)),
        font: colors('white'),
        border: colors(getColorSeverity(WARNING)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(WARNING), 400),
        border: colors(getColorSeverity(WARNING), 400),
      },
    },
    outlinedNeutral: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(WARNING)),
        border: colors('grey', 200),
      },
      hovered: {
        bg: colors(getColorSeverity(WARNING)),
        font: colors('white'),
        border: colors(getColorSeverity(WARNING)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(WARNING), 400),
        border: colors('grey', 200),
      },
    },
  },
  success: {
    default: {
      default: {
        bg: colors(getColorSeverity(SUCCESS)),
        font: colors('white'),
        border: colors(getColorSeverity(SUCCESS)),
      },
      hovered: {
        bg: colors(getColorSeverity(SUCCESS), 600),
        font: colors('white'),
        border: colors(getColorSeverity(SUCCESS), 600),
      },
      disabled: {
        bg: colors(getColorSeverity(SUCCESS), 400),
        font: colors('white'),
        border: colors(getColorSeverity(SUCCESS), 400),
      },
    },
    outlined: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(SUCCESS)),
        border: colors(getColorSeverity(SUCCESS)),
      },
      hovered: {
        bg: colors(getColorSeverity(SUCCESS)),
        font: colors('white'),
        border: colors(getColorSeverity(SUCCESS)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(SUCCESS), 400),
        border: colors(getColorSeverity(SUCCESS), 400),
      },
    },
    outlinedNeutral: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(SUCCESS)),
        border: colors('grey', 200),
      },
      hovered: {
        bg: colors(getColorSeverity(SUCCESS)),
        font: colors('white'),
        border: colors(getColorSeverity(SUCCESS)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(SUCCESS), 400),
        border: colors('grey', 200),
      },
    },
  },
  danger: {
    default: {
      default: {
        bg: colors(getColorSeverity(DANGER)),
        font: colors('white'),
        border: colors(getColorSeverity(DANGER)),
      },
      hovered: {
        bg: colors(getColorSeverity(DANGER), 600),
        font: colors('white'),
        border: colors(getColorSeverity(DANGER), 600),
      },
      disabled: {
        bg: colors(getColorSeverity(DANGER), 400),
        font: colors('white'),
        border: colors(getColorSeverity(DANGER), 400),
      },
    },
    outlined: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(DANGER)),
        border: colors(getColorSeverity(DANGER)),
      },
      hovered: {
        bg: colors(getColorSeverity(DANGER)),
        font: colors('white'),
        border: colors(getColorSeverity(DANGER)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(DANGER), 400),
        border: colors(getColorSeverity(DANGER), 400),
      },
    },
    outlinedNeutral: {
      default: {
        bg: colors('white'),
        font: colors(getColorSeverity(DANGER)),
        border: colors('grey', 200),
      },
      hovered: {
        bg: colors(getColorSeverity(DANGER)),
        font: colors('white'),
        border: colors(getColorSeverity(DANGER)),
      },
      disabled: {
        bg: colors('white'),
        font: colors(getColorSeverity(DANGER), 400),
        border: colors('grey', 200),
      },
    },
  },
  plain: {
    default: {
      default: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
      hovered: {
        bg: 'transparent',
        font: colors('black'),
        border: 'transparent',
      },
      disabled: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
    },
    outlined: {
      default: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
      hovered: {
        bg: 'transparent',
        font: colors('black'),
        border: 'transparent',
      },
      disabled: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
    },
    outlinedNeutral: {
      default: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
      hovered: {
        bg: 'transparent',
        font: colors('black'),
        border: 'transparent',
      },
      disabled: {
        bg: 'transparent',
        font: colors('grey'),
        border: 'transparent',
      },
    },
  },
  bleen: {
    default: {
      default: {
        bg: colors('bleen', 400),
        font: colors('white'),
        border: colors('bleen', 400),
      },
      hovered: {
        bg: colors('bleen', 500),
        font: colors('white'),
        border: colors('bleen', 500),
      },
      disabled: {
        bg: colors('bleen', 300),
        font: colors('white'),
        border: colors('bleen', 300),
      },
    },
    outlined: {
      default: {
        bg: colors('white'),
        font: colors('bleen', 400),
        border: colors('bleen', 400),
      },
      hovered: {
        bg: colors('bleen', 400),
        font: colors('white'),
        border: colors('bleen', 400),
      },
      disabled: {
        bg: colors('white'),
        font: colors('bleen', 300),
        border: colors('bleen', 300),
      },
    },
    outlinedNeutral: {
      default: {
        bg: 'transparent',
        font: colors('white'),
        border: colors('white'),
      },
      hovered: {
        bg: colors('white'),
        font: colors('bleen', 400),
        border: colors('white'),
      },
      disabled: {
        bg: colors('white', 400),
        font: colors('bleen', 300),
        border: colors('white', 400),
      },
    },
  },
} satisfies Record<string, ButtonColorDefinition>;

export type ButtonMode = keyof typeof buttonColors;
